export default __webpack_public_path__ + "static/media/Slide19.607789cf.jpg";